import React from 'react'

export type DashboardEditableRowSlotState = {
  inSlot: boolean
  /** False when this row has only one section — no reorder/resize affordances. */
  multiSectionLayout: boolean
}

const defaultSlotState: DashboardEditableRowSlotState = {
  inSlot: false,
  multiSectionLayout: false,
}

const DashboardEditableRowSlotContext =
  React.createContext<DashboardEditableRowSlotState>(defaultSlotState)

/** Marks descendants as living inside a `DashboardEditableRow` cell. */
export function DashboardEditableRowSlotProvider({
  children,
  multiSectionLayout,
}: {
  children: React.ReactNode
  multiSectionLayout: boolean
}): React.ReactElement {
  return (
    <DashboardEditableRowSlotContext.Provider
      value={{ inSlot: true, multiSectionLayout }}
    >
      {children}
    </DashboardEditableRowSlotContext.Provider>
  )
}

export function useDashboardEditableRowSlot(): DashboardEditableRowSlotState {
  return React.useContext(DashboardEditableRowSlotContext)
}
